/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {AugmentedSmarterTrailerSensorData, SensorTypes} from '@ion/core/src/types/entities';
import BrakeChamberSection from './BrakeChamberSection';
import CargoSenseSection from './CargoSenseSection';
import DoorSensorSection from './DoorSensorSection';
import LightOutDetectionSection from './LightOutDetectionSection';
import TiresSection from './TiresSection';
import WeightSection from './WeightSection';

export type SensorDetailProps ={
  selectedSensor: SensorTypes;
  smarterTrailer: AugmentedSmarterTrailerSensorData,
  loading: boolean,
  onViewTireSensorReport: Function | null;
};

/**
 * This component is responsible for rendering the detailed component of
 * the selected sensor.
 *
 * ```typescript
 *
 * import SmarterTrailerSensorDetails from './SmarterTrailerSensorDetails';
 *
 *  <SmarterTrailerSensorDetails selectedSensor={selectedSensor}
 *    onViewTireSensorReport={onViewTireSensorReport}
 *    smarterTrailer={smarterTrailer}
 *    loading={loading} />
 *
 * ```
 */
const SmarterTrailerSensorDetails = ({
  selectedSensor,
  smarterTrailer,
  loading,
  onViewTireSensorReport
}: SensorDetailProps) => {
  const sensorDetailMap = {
    [SensorTypes.CargoSense] : CargoSenseSection,
    [SensorTypes.DoorState]  : DoorSensorSection,
    [SensorTypes.TPMS]       : TiresSection,
    [SensorTypes.WETS]       : TiresSection,
    [SensorTypes.BMS]        : BrakeChamberSection,
    [SensorTypes.WMS]        : WeightSection,
    [SensorTypes.LMS]        : LightOutDetectionSection
  };

  return (
    <>
      {sensorDetailMap?.[selectedSensor]?.({
        selectedSensor         : selectedSensor,
        sensorUpdateLoading    : loading,
        trailerData            : smarterTrailer,
        onViewTireSensorReport : onViewTireSensorReport
      })}
    </>
  );
};

export default SmarterTrailerSensorDetails;
